


export function post_variant(urlprefix, token, data){
    return fetch(urlprefix + "/participant/post_variants",
        {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': "application/json",
                'Authorization': token
            },
            body: JSON.stringify(data)}

    )
}


export function update_variants(urlprefix, token, data, string){
    return fetch(urlprefix + "/participant/tag_variants/" + string,
        {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': "application/json",
                'Authorization': token
            },
            body: JSON.stringify(data)}

    )
}


export function delete_variants(urlprefix, token, data, string){
    return fetch(urlprefix + "/participant/tag_variants/" + string,
        {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': "application/json",
                'Authorization': token
            },
            body: JSON.stringify(data)
        }

    )
}

export function get_sample_variants(urlprefix, token, string){
    return fetch(urlprefix + "/participant/tag_variants/" + string,
        {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': "application/json",
                'Authorization': token
            }
        }

    )
}


export function get_all_variants(urlprefix, token){


    let assemblyID = (window.config.genome_ref === "hg38") ? "hg38" : "hg19";


    return fetch(urlprefix + "/get_all_variants" + "?assemblyId=" + assemblyID,
        {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': "application/json",
                'Authorization': token
            }
        }

    )
}


export function tagged_variants_request(urlprefix, token, geneList){

   let assemblyId = window.config.genome_ref === "hg38" ? "hg38" : "hg19"; 
   const data_object =  {"assemblyId": assemblyId,"genes":geneList.genes}

   return fetch(urlprefix + "/post_all_variants",
    {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': "application/json",
            'Authorization': token
        },
        body: JSON.stringify(data_object)
    }

)

}